import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Popover
 */
import { getDefaultElementBoundary, getDefaultElementOffset, getDefaultElementPosition } from '@tencent/glue-util-boundary';
import { getDocScroll, getElementBoundary, getWindowSize, isFixed } from '@tencent/glue-dom-boundary';
import { assign, clone, guid, shallowEqual } from '@tencent/glue-util-helper';
import { Emitter } from '@tencent/glue-util-emitter';
export var reversedDirection = {
  left: 'right',
  top: 'bottom',
  right: 'left',
  bottom: 'top'
};
export var touchReverse = {
  left: 'right',
  top: 'bottom',
  right: 'left',
  bottom: 'top'
};
export function getDefaultTouch() {
  return {
    touchX: false,
    touchY: false,
    fixed: false
  };
}
export function getDefaultArrowInfo(placement) {
  var arrowInfo = {
    arrowStyle: {},
    arrowDirection: ''
  };

  if (!placement) {
    return arrowInfo;
  }

  var _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 1),
      dir = _placement$split2[0];

  assign(arrowInfo, {
    arrowDirection: touchReverse[dir]
  });
  return arrowInfo;
}
export var Popover = /*#__PURE__*/function (_Emitter) {
  _inherits(Popover, _Emitter);

  var _super = _createSuper(Popover);

  function Popover(params) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this);
    _this.arrowInfo = getDefaultArrowInfo();
    _this.arrow = false;
    _this.triggerIds = [];
    _this.lastTrigger = '';
    _this.sideDirectionDict = {
      top: {
        sides: ['left', 'right'],
        range: 'width'
      },
      bottom: {
        sides: ['left', 'right'],
        range: 'width'
      },
      left: {
        sides: ['top', 'bottom'],
        range: 'height'
      },
      right: {
        sides: ['top', 'bottom'],
        range: 'height'
      }
    }; // lastTrigger 根据最终的activeTrigger定位
    // trigger  根据 refId 对应的trigger定位
    // popover  根据 refId 对应的popover定位

    _this.refType = 'lastTrigger'; // 触发popover show/hide 相对定位元素

    _this.refId = ''; // 关联popover，保证show操作同步使用

    _this.unionPopoverIds = [];
    _this.placement = 'bottom-start';
    _this.offset = getDefaultElementOffset();
    _this.preventOverflow = true;
    _this.boundariesDetectionDebounce = false;
    _this.overflowBoundaries = getDefaultElementPosition();
    _this.arrowOffset = getDefaultElementOffset();
    _this.popoverTouch = getDefaultTouch();
    _this.popover = null;
    _this.container = null;
    _this.popoverStyle = {};
    _this.preventAroundOverflow = false;
    _this.rect = getDefaultElementBoundary();
    _this.disposed = false;
    _this.id = params.id || guid();
    _this.popper = params.popper;
    _this.singleGroupId = params.singleGroupId || _this.id;

    _this.popper.registerPopover(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(Popover, [{
    key: "updatePopover",
    value: function updatePopover(element) {
      this.popover = element;
    }
  }, {
    key: "updateContainer",
    value: function updateContainer(element) {
      this.container = element;
    }
  }, {
    key: "updatePopoverOptions",
    value: function updatePopoverOptions(options) {
      var _options$show = options.show,
          show = _options$show === void 0 ? false : _options$show,
          _options$refType = options.refType,
          refType = _options$refType === void 0 ? 'lastTrigger' : _options$refType,
          _options$refId = options.refId,
          refId = _options$refId === void 0 ? '' : _options$refId,
          _options$triggerIds = options.triggerIds,
          triggerIds = _options$triggerIds === void 0 ? [] : _options$triggerIds,
          _options$unionPopover = options.unionPopoverIds,
          unionPopoverIds = _options$unionPopover === void 0 ? [] : _options$unionPopover,
          _options$placement = options.placement,
          placement = _options$placement === void 0 ? 'bottom-start' : _options$placement,
          _options$offset = options.offset,
          offset = _options$offset === void 0 ? getDefaultElementOffset() : _options$offset,
          _options$preventOverf = options.preventOverflow,
          preventOverflow = _options$preventOverf === void 0 ? true : _options$preventOverf,
          _options$overflowBoun = options.overflowBoundaries,
          overflowBoundaries = _options$overflowBoun === void 0 ? getDefaultElementPosition() : _options$overflowBoun,
          _options$arrow = options.arrow,
          arrow = _options$arrow === void 0 ? false : _options$arrow,
          _options$arrowOffset = options.arrowOffset,
          arrowOffset = _options$arrowOffset === void 0 ? getDefaultElementOffset() : _options$arrowOffset,
          _options$preventAroun = options.preventAroundOverflow,
          preventAroundOverflow = _options$preventAroun === void 0 ? false : _options$preventAroun,
          _options$boundariesDe = options.boundariesDetectionDebounce,
          boundariesDetectionDebounce = _options$boundariesDe === void 0 ? false : _options$boundariesDe;
      this.refType = refType;
      this.refId = refId;
      this.triggerIds = triggerIds;
      this.unionPopoverIds = unionPopoverIds;
      this.placement = placement;
      this.offset = offset;
      this.preventOverflow = preventOverflow;
      this.boundariesDetectionDebounce = boundariesDetectionDebounce;
      this.overflowBoundaries = overflowBoundaries;
      this.preventAroundOverflow = preventAroundOverflow;
      this.arrow = arrow;
      this.arrowOffset = arrowOffset;
      this.popper.setPopoverShow(this.id, show); // placement 改变需 updatePopperStyle

      this.popoverStyle = this.updatePopperStyle();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.popper.unregisterPopover(this);
      this.disposed = true;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.singleGroupId;
    }
  }, {
    key: "getPopoverStyle",
    value: function getPopoverStyle() {
      return this.popoverStyle || {};
    }
  }, {
    key: "getArrowStyle",
    value: function getArrowStyle() {
      return this.arrowInfo.arrowStyle || {};
    }
  }, {
    key: "getPopoverFixed",
    value: function getPopoverFixed() {
      var ref = this.getPopover();

      if (ref == null) {
        return false;
      }

      return isFixed(ref);
    }
  }, {
    key: "getTriggerIds",
    value: function getTriggerIds() {
      return this.triggerIds;
    }
  }, {
    key: "getRefId",
    value: function getRefId() {
      return this.refId;
    }
  }, {
    key: "getRefType",
    value: function getRefType() {
      return this.refType;
    }
  }, {
    key: "setLastTrigger",
    value: function setLastTrigger(triggerId) {
      this.lastTrigger = triggerId;
    }
  }, {
    key: "getLastTrigger",
    value: function getLastTrigger() {
      return this.lastTrigger;
    }
  }, {
    key: "getUnionPopoverIds",
    value: function getUnionPopoverIds() {
      return this.unionPopoverIds;
    }
  }, {
    key: "showPopover",
    value: function showPopover() {
      this.popoverStyle = this.updatePopperStyle();

      if (this.popper.isActiveShow(this.lastTrigger)) {
        this.emit('popover-style', this.popoverStyle);
        return;
      }

      this.popper.syncSingleGroup(this.getGroupId(), this.getId());
      this.popper.setActiveShow(this.lastTrigger);
      this.emit('last-trigger-update');
      this.emit('popover-show', true);
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      this.lastTrigger && this.popper.cancelActiveShow(this.lastTrigger);
      this.emit('popover-show', false);
    }
  }, {
    key: "isShow",
    value: function isShow() {
      return this.popper.isPopoverShow(this.id);
    }
  }, {
    key: "updateRefRect",
    value: function updateRefRect() {
      this.popoverStyle = this.updatePopperStyle();

      if (this.isShow()) {
        this.emit('popover-style', this.popoverStyle);
      }
    }
  }, {
    key: "updateRect",
    value: function updateRect(rect) {
      this.rect = rect;
      this.popoverStyle = this.updatePopperStyle();

      if (this.isShow()) {
        this.emit('popover-style', this.popoverStyle);
        this.popper.updatePopoverRect(this.id);
      }
    }
  }, {
    key: "getRect",
    value: function getRect() {
      return this.rect;
    }
  }, {
    key: "getTriggerData",
    value: function getTriggerData() {
      if (!this.lastTrigger) {
        return null;
      }

      return this.popper.getTrigger(this.lastTrigger).getData();
    }
  }, {
    key: "getRealPlacement",
    value: function getRealPlacement() {
      var placement = this.placement;
      var touch = this.popoverTouch;

      var _placement$split3 = placement.split('-'),
          _placement$split4 = _slicedToArray(_placement$split3, 2),
          first = _placement$split4[0],
          second = _placement$split4[1];

      var reversed = ['top', 'bottom'].includes(first) ? touch.touchY : touch.touchX;
      return "".concat(reversed ? touchReverse[first] : first).concat(second ? '-' + second : '');
    }
  }, {
    key: "onPopperMouseEnter",
    value: function onPopperMouseEnter() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'hover') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).showPopper();
    }
  }, {
    key: "onPopperMouseLeave",
    value: function onPopperMouseLeave() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'hover') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).hidePopper();
    }
  }, {
    key: "onPopperFocus",
    value: function onPopperFocus() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'focus') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).showPopper();
    }
  }, {
    key: "onPopperBlur",
    value: function onPopperBlur() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'focus') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).hidePopper();
    }
  }, {
    key: "getRefTriggerId",
    value: function getRefTriggerId() {
      var refId = this.refId,
          refType = this.refType;

      if (refType === 'trigger') {
        return refId;
      }

      if (refType === 'popover') {
        return '';
      }

      return this.getLastTrigger();
    }
  }, {
    key: "getRefFixed",
    value: function getRefFixed() {
      try {
        switch (this.refType) {
          case 'trigger':
            return this.popper.getTrigger(this.refId).isTriggerFixed();

          case 'popover':
            return this.popper.getPopover(this.refId).getPopoverFixed();

          case 'lastTrigger':
            return this.popper.getTrigger(this.lastTrigger).isTriggerFixed();

          default:
            return false;
        }
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "getRefRect",
    value: function getRefRect() {
      var ref = null;

      switch (this.refType) {
        case 'trigger':
          ref = this.popper.getTrigger(this.refId);
          break;

        case 'popover':
          ref = this.popper.getPopover(this.refId);
          break;

        case 'lastTrigger':
          ref = this.popper.getTrigger(this.lastTrigger);
      }

      return ref ? ref.getRect() : getDefaultElementBoundary();
    }
  }, {
    key: "updatePopperStyle",
    value: function updatePopperStyle() {
      var popoverRect = _objectSpread({}, this.rect);

      var refRect = this.getRefRect();
      var containerPos = this.getContainerPos();

      var _this$getOffsetByPlac = this.getOffsetByPlacement(),
          x = _this$getOffsetByPlac.x,
          y = _this$getOffsetByPlac.y;

      var left = refRect.left + x + (this.offset.x || 0);
      var top = refRect.top + y + (this.offset.y || 0);
      assign(popoverRect, {
        left: left,
        top: top,
        right: left + popoverRect.width,
        bottom: top + popoverRect.height
      });

      var _this$getRectByOverfl = this.getRectByOverflowBoundaries(popoverRect, this.popoverTouch),
          _this$getRectByOverfl2 = _slicedToArray(_this$getRectByOverfl, 2),
          touchPopperRect = _this$getRectByOverfl2[0],
          touch = _this$getRectByOverfl2[1];

      var fixed = !this.isContainerFixed() && (this.getRefFixed() || touch.fixed);
      var popStyle = {
        position: fixed ? 'fixed' : 'absolute'
      };

      var _getDocScroll = getDocScroll(),
          horizontal = _getDocScroll.horizontal,
          vertical = _getDocScroll.vertical;

      if (fixed) {
        horizontal = 0;
        vertical = 0;
      }

      horizontal -= containerPos.left;
      vertical -= containerPos.top;

      if (this.preventOverflow && (touch.touchX || touch.touchY)) {
        popStyle.left = Math.floor(touchPopperRect.left + horizontal) + 'px';
        popStyle.top = Math.floor(touchPopperRect.top + vertical) + 'px';
      } else {
        popStyle.left = Math.floor(popoverRect.left + horizontal) + 'px';
        popStyle.top = Math.floor(popoverRect.top + vertical) + 'px';
      }

      if (this.arrow) {
        this.arrowInfo = this.getArrowInfo(popoverRect, touch);
        this.emit('arrow-info-change', this.arrowInfo);
      }

      if (!shallowEqual(this.popoverTouch, touch)) {
        this.popoverTouch = touch;
        this.emit('touch-change', touch);
      }

      return popStyle;
    }
  }, {
    key: "getArrowInfo",
    value: function getArrowInfo(popoverRect, popoverTouch) {
      var _this$placement$split = this.placement.split('-'),
          _this$placement$split2 = _slicedToArray(_this$placement$split, 2),
          direction = _this$placement$split2[0],
          _this$placement$split3 = _this$placement$split2[1],
          pos = _this$placement$split3 === void 0 ? 'center' : _this$placement$split3;

      var touchX = popoverTouch.touchX,
          touchY = popoverTouch.touchY;
      var arrowStyle = {
        position: 'absolute',
        lineHeight: 0,
        fontSize: 0
      };
      var isVertical = direction === 'top' || direction === 'bottom';
      var axisPos = {
        vertical: {
          start: this.arrowOffset.y,
          center: popoverRect.height / 2 + this.arrowOffset.y,
          end: popoverRect.height + this.arrowOffset.y
        },
        horizontal: {
          start: this.arrowOffset.x,
          center: popoverRect.width / 2 + this.arrowOffset.x,
          end: popoverRect.width + this.arrowOffset.x
        }
      };
      var transformPos = {
        start: '0',
        center: '-50%',
        end: '-100%'
      };
      var dir = isVertical ? touchY ? touchReverse[direction] : direction : touchX ? touchReverse[direction] : direction;

      switch (dir) {
        case 'right':
          assign(arrowStyle, {
            left: 0,
            transform: "translate(-100%, ".concat(transformPos[pos], ")"),
            top: axisPos.vertical[pos] + 'px'
          });
          break;

        case 'left':
          assign(arrowStyle, {
            left: popoverRect.width + 'px',
            transform: "translate(0, ".concat(transformPos[pos], ")"),
            top: axisPos.vertical[pos] + 'px'
          });
          break;

        case 'bottom':
          assign(arrowStyle, {
            top: 0,
            transform: "translate(".concat(transformPos[pos], ", -100%)"),
            left: axisPos.horizontal[pos] + 'px'
          });
          break;

        case 'top':
          assign(arrowStyle, {
            top: popoverRect.height + 'px',
            transform: "translate(".concat(transformPos[pos], ", 0)"),
            left: axisPos.horizontal[pos] + 'px'
          });
          break;
      }

      return {
        arrowStyle: arrowStyle,
        arrowDirection: touchReverse[dir]
      };
    }
  }, {
    key: "getOffsetByPlacement",
    value: function getOffsetByPlacement() {
      var _this$placement$split4 = this.placement.split('-'),
          _this$placement$split5 = _slicedToArray(_this$placement$split4, 2),
          direction = _this$placement$split5[0],
          _this$placement$split6 = _this$placement$split5[1],
          pos = _this$placement$split6 === void 0 ? 'center' : _this$placement$split6;

      var _this$rect = this.rect,
          popoverWidth = _this$rect.width,
          popoverHeight = _this$rect.height;

      var _this$getRefRect = this.getRefRect(),
          refWidth = _this$getRefRect.width,
          refHeight = _this$getRefRect.height;

      var res = getDefaultElementOffset();
      var axisOffset = {
        vertical: {
          start: 0,
          center: (refWidth - popoverWidth) / 2,
          end: refWidth - popoverWidth
        },
        horizontal: {
          start: 0,
          center: (refHeight - popoverHeight) / 2,
          end: refHeight - popoverHeight
        }
      };

      switch (direction) {
        case 'top':
          assign(res, {
            y: -popoverHeight,
            x: axisOffset.vertical[pos]
          });
          break;

        case 'bottom':
          assign(res, {
            y: refHeight,
            x: axisOffset.vertical[pos]
          });
          break;

        case 'left':
          assign(res, {
            y: axisOffset.horizontal[pos],
            x: -popoverWidth
          });
          break;

        case 'right':
          assign(res, {
            y: axisOffset.horizontal[pos],
            x: refWidth
          });
          break;
      }

      return res;
    } // 获取当前视口的boundaries

  }, {
    key: "getAvailBoundaries",
    value: function getAvailBoundaries() {
      var _this$overflowBoundar = this.overflowBoundaries,
          _this$overflowBoundar2 = _this$overflowBoundar.left,
          left = _this$overflowBoundar2 === void 0 ? 0 : _this$overflowBoundar2,
          _this$overflowBoundar3 = _this$overflowBoundar.top,
          top = _this$overflowBoundar3 === void 0 ? 0 : _this$overflowBoundar3,
          _this$overflowBoundar4 = _this$overflowBoundar.right,
          right = _this$overflowBoundar4 === void 0 ? 0 : _this$overflowBoundar4,
          _this$overflowBoundar5 = _this$overflowBoundar.bottom,
          bottom = _this$overflowBoundar5 === void 0 ? 0 : _this$overflowBoundar5;

      var _getWindowSize = getWindowSize(),
          width = _getWindowSize.width,
          height = _getWindowSize.height;

      return {
        left: left,
        top: top,
        right: width - right,
        bottom: height - bottom
      };
    }
  }, {
    key: "getRectByOverflowBoundaries",
    value: function getRectByOverflowBoundaries(popoverRect, currentTouch) {
      var newRect = clone(popoverRect);
      var availBoundaries = this.getAvailBoundaries();
      var direction = this.placement.split('-')[0];
      var isVertical = direction === 'top' || direction === 'bottom';
      var res = getDefaultTouch();
      var refRect = this.getRefRect();
      var shouldFlip = this.boundariesDetectionDebounce && currentTouch[isVertical ? 'touchY' : 'touchX'] || this.isRectOverBoundary(availBoundaries, newRect, direction); // 调整位置后 * bugfix: 前置检测

      if (shouldFlip) {
        var reversedDir = reversedDirection[direction];
        var nextValue = refRect[reversedDir] - this.offset[isVertical ? 'y' : 'x'];

        var flippedRect = _objectSpread({}, newRect);

        this.assignRectValue(flippedRect, direction, nextValue); // 翻转位置后仍然超出边界，使用原先的位置，否则使用翻转后的 rect

        if (this.isRectOverBoundary(availBoundaries, flippedRect, reversedDir)) {
          this.assignRectValue(newRect, direction, nextValue);
        } else {
          res[isVertical ? 'touchY' : 'touchX'] = true;
          assign(newRect, flippedRect);
        }
      } // 其他方向检测: 例如右对齐同时底部空间不够（menu）


      var _this$sideDirectionDi = this.sideDirectionDict[direction],
          sides = _this$sideDirectionDi.sides,
          range = _this$sideDirectionDi.range;

      if (!this.preventAroundOverflow || newRect[range] > getWindowSize()[range]) {
        return [newRect, res];
      }

      var _iterator = _createForOfIteratorHelper(sides),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var side = _step.value;

          if (this.isRectOverBoundary(availBoundaries, newRect, side)) {
            var _isVertical = side === 'top' || side === 'bottom';

            res[_isVertical ? 'touchY' : 'touchX'] = true;
            var _nextValue = availBoundaries[side];
            this.assignRectValue(newRect, side, _nextValue); // 调整位置后仍然超出边界，则使用 fixed 绝对定位
            // if (this.isRectOverBoundary(availBoundaries, newRect, side)) {
            //     res.fixed = true;
            //     this.assignRectValue(newRect, side, availBoundaries[side]);
            // }

            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return [newRect, res];
    }
  }, {
    key: "getPopover",
    value: function getPopover() {
      return this.popover || null;
    }
  }, {
    key: "assignRectValue",
    value: function assignRectValue(rect, direction, value) {
      if (direction === 'top') {
        rect.top = value;
        rect.bottom = rect.top + rect.height;
      } else if (direction === 'left') {
        rect.left = value;
        rect.right = rect.left + rect.width;
      } else if (direction === 'right') {
        rect.right = value;
        rect.left = rect.right - rect.width;
      } else {
        rect.bottom = value;
        rect.top = rect.bottom - rect.height;
      }
    }
  }, {
    key: "isRectOverBoundary",
    value: function isRectOverBoundary(boundary, rect, direction) {
      if (direction === 'top' || direction === 'left') {
        return boundary[direction] > rect[direction];
      }

      return boundary[direction] < rect[direction];
    }
  }, {
    key: "getContainerPos",
    value: function getContainerPos() {
      var container = this.container; // container为body时，当做没有父容器处理

      if (container === document.body || container == null) {
        return getDefaultElementBoundary();
      }

      var containerPos = getElementBoundary(container); // popover的位置计算了scroll，而useElementPosition获取的是可视区定位，需要加上scroll才能算对容器绝对位置

      var documentScroll = this.getRefFixed() ? {
        horizontal: 0,
        vertical: 0
      } : getDocScroll();
      return _objectSpread(_objectSpread({}, containerPos), {}, {
        left: containerPos.left + documentScroll.horizontal,
        top: containerPos.top + documentScroll.vertical
      });
    }
  }, {
    key: "isContainerFixed",
    value: function isContainerFixed() {
      var container = this.container;
      return container != null && isFixed(container);
    }
  }]);

  return Popover;
}(Emitter);